import { useMemo } from 'react';
import { WsSelect } from 'wisestep-base';

import useListingSettings from '../../../features/jobs/listing/hooks/useListingSettings';
import WsFilterProps from '../models/WsFilterProps';

const JobWorkplacePreferenceFilter = ({
  name,
  label = '',
  showMandatorySymbol = false,
}: WsFilterProps) => {
  const { jobFieldSettings } = useListingSettings();

  const workplacePreferenceTypes = useMemo(
    () =>
      jobFieldSettings.workplacePreference?.availableFields?.map((wp) => ({
        label: wp,
        value: wp,
      })),
    [jobFieldSettings.workplacePreference.availableFields]
  );

  return (
    <WsSelect
      name={name}
      selectArray={workplacePreferenceTypes}
      label={label}
      showMandatorySymbol={showMandatorySymbol}
    />
  );
};

export default JobWorkplacePreferenceFilter;
